import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "fees",
    name: "fees",
    component: () => import("./pages/FeesPage.vue"),
    meta: { title: "menu.fees", requiresAuth: true, requiresStaff: true },
  },
  {
    path: "activity-fees",
    name: "activity-fees",
    component: () => import("./pages/ActivityFeesPage.vue"),
    meta: { title: "menu.activity_fees", requiresAuth: true, requiresStaff: true },
  },
  {
    path: "my-fee",
    redirect: { name: "my-family" },
  },
];
